import * as React from 'react';
import styled from 'styled-components';
import { selectThemeSemantics } from '../../../styling';
import { Typography } from '../../typography';
import { IFlyoutProps } from '../flyout-props';
import { FlexBox } from '../../flex-box';
import { isString } from '@agilepoint/utils-common';
import { PlainButton } from '../../button';
import { Icon } from '../../icon';

const HeaderWrapper = styled(FlexBox).attrs(() => ({
    className: String('ap-flyout-headerWrapper')
}))`
    width: 100%;
    box-sizing: border-box;
    min-height: 60px;
    height: auto;
    padding: ${selectThemeSemantics(({ gap }) => `${gap.none} ${gap.xxxxl}`)};
`;

const Title = styled(Typography.H4).attrs(() => ({
    className: String('ap-flyout-title')
}))`
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: calc(100% - 20px);
    display: inline-block;
`;

const TitleSeparator = styled.hr.attrs({
    className: 'ap-flyout-titleSeparator'
})`
    width: 100%;
    height: 1px;
    border: ${selectThemeSemantics(({ gap }) => gap.none)};
    margin: ${selectThemeSemantics(({ gap }) => gap.none)};
    background-color: ${({ theme: { flyout: { colors: { titleSeparatorColor } } } }) => titleSeparatorColor};
`;

const CloseButton = styled(PlainButton).attrs({
    className: String('ap-flyout-closeButton')
})`
${Icon} {
    fill: ${({ theme: { flyout: { colors } } }) => colors.closeButtonColor};
}
`;

export interface IFlyoutHeaderProps extends Pick<IFlyoutProps, 'showTitleSeparator'> {
    title?: string | React.ReactElement;
    onCloseFlyout(ev?: React.MouseEvent): void;
}

export function FlyoutHeader(props: IFlyoutHeaderProps) {
    const { onCloseFlyout, title, showTitleSeparator } = props;
    return (
        <div>
            <HeaderWrapper alignItems="center" justifyContent={title ? 'space-between' : 'flex-end'}>
                <Title hidden={title === undefined} title={isString(title) ? title : undefined}>{title}</Title>
                <CloseButton
                    title="Close"
                    onClick={onCloseFlyout}
                    size="small"
                    iconName="ap-close2.outline"
                    iconSize="12"
                />
            </HeaderWrapper>
            {showTitleSeparator && <TitleSeparator />}
        </div>
    );
}
